import { observer } from 'mobx-react-lite'
import { type JobNotesViewModel } from '@/features/jobs/details/components/JobNotesCard/JobNotesViewModel'
import { type JobNoteItemViewModel } from '@/features/jobs/details/components/JobNotesCard/JobNoteItem/JobNoteItemViewModel'
import { NoteCard } from '@/features/jobs/details/components/JobSections/NoteCard'

export interface NoteCardContainerProps {
  vm: JobNotesViewModel
  noteVm: JobNoteItemViewModel
}

export const NoteCardContainer = observer(function NoteCardContainer({
  vm,
  noteVm,
}: NoteCardContainerProps) {
  return (
    <NoteCard
      id={noteVm.id}
      author={{
        avatar: noteVm.author.avatar,
        avatarFallback: noteVm.author.avatarFallback,
        displayName: noteVm.author.displayName,
      }}
      displayName={noteVm.displayName}
      formattedTime={noteVm.formattedTime}
      role={noteVm.role}
      mentions={noteVm.mentions}
      body={noteVm.body}
      canDelete={vm.canDelete(noteVm)}
      onDelete={() => vm.deleteNote(noteVm)}
    />
  )
})
